import { Alert } from "ebs-design";

import { extractErrorMessages } from "@aeo/core/utils";
import { NO_AVAILABLE_ERRORS_MESSAGE } from "@aeo/core/app-constants";

export interface AlertErrorsProps {
  error: any;
  alertsClassName?: string;
}

export const AlertErrors = ({
  error,
  alertsClassName = "my-2",
}: AlertErrorsProps) => {
  if (!error) return null;
  const messages = extractErrorMessages(error);

  if (messages.length) {
    return (
      <>
        {messages.map((m, i) => (
          <Alert key={i} className={alertsClassName} type="error">
            {m}
          </Alert>
        ))}
      </>
    );
  }

  if (error.message) {
    return (
      <Alert className={alertsClassName} type="error">
        {error.message}
      </Alert>
    );
  }

  return (
    <Alert className={alertsClassName} type="error">
      {NO_AVAILABLE_ERRORS_MESSAGE}
    </Alert>
  );
};
